import {faGlass} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

interface ITopBeerProps {
  beerLogo: string | null;
  name: string;
  abv: string;
  breweryName: string;
}

const TopBeer = ({beerLogo, name, abv, breweryName}: ITopBeerProps) => {
  return (
    <div className="manager-page__top-single">
      <div className="manager-page__single-wrapper">
        <div className="manager-page__single-title">
          {beerLogo ? (
            <img className="manager-page__single-image" src={beerLogo} alt={`${name} beer`} />
          ) : (
            <div className="manager-page__single-image-placeholder">
              <FontAwesomeIcon icon={faGlass} />
            </div>
          )}
          <p>{name}</p>
        </div>
        <div className="manager-page__single-creator">{breweryName}</div>
        <div className="manager-page__single-stat">
          ABV:<span> {abv} % </span>
        </div>
      </div>
    </div>
  );
};

export default TopBeer;
